import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './VideoGallerySection.css';

const VideoGallerySection: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const videos = [
    {
      id: 'video1',
      title: 'Web Development Full Course',
      youtubeId: 'RDrwmwQMScw',
      thumbnail: 'https://img.youtube.com/vi/RDrwmwQMScw/maxresdefault.jpg'
    },
    {
      id: 'video2',
      title: 'HTML & CSS Crash Course',
      youtubeId: 'xC1XR6rS4KI',
      thumbnail: 'https://img.youtube.com/vi/xC1XR6rS4KI/maxresdefault.jpg'
    },
    {
      id: 'video3',
      title: 'JavaScript Fundamentals',
      youtubeId: 'e_tpEbWUHS8',
      thumbnail: 'https://img.youtube.com/vi/e_tpEbWUHS8/maxresdefault.jpg'
    },
    {
      id: 'video4',
      title: 'React.js Tutorial',
      youtubeId: 'ZSWTqhQrbTg',
      thumbnail: 'https://img.youtube.com/vi/ZSWTqhQrbTg/maxresdefault.jpg'
    },
    {
      id: 'video5',
      title: 'Node.js & Express Guide',
      youtubeId: 'uGdUvg9FYVI',
      thumbnail: 'https://img.youtube.com/vi/uGdUvg9FYVI/maxresdefault.jpg'
    },
    {
      id: 'video6',
      title: 'MongoDB for Beginners',
      youtubeId: 'bIlb5ZPq1gQ',
      thumbnail: 'https://img.youtube.com/vi/bIlb5ZPq1gQ/maxresdefault.jpg'
    },
    {
      id: 'video7',
      title: 'Full Stack Development',
      youtubeId: 'q-UBrwtlwsM',
      thumbnail: 'https://img.youtube.com/vi/q-UBrwtlwsM/maxresdefault.jpg'
    },
    {
      id: 'video8',
      title: 'Web Dev Best Practices',
      youtubeId: 'pQrMjuRmrK8',
      thumbnail: 'https://img.youtube.com/vi/pQrMjuRmrK8/maxresdefault.jpg'
    }
  ];

  const openYouTubeVideo = (videoId: string) => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <section className="video-gallery-section" id="videos">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          ref={ref}
        >
          <h2 className="section-title" style={{
            background: 'linear-gradient(135deg, #6366f1, #10b981)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
            marginBottom: '1rem'
          }}>
            Learn <span style={{ color: 'inherit' }}>Web Development</span> for Free
          </h2>
          <p className="section-subtitle" style={{ color: '#1f2937', maxWidth: '700px', margin: '0 auto' }}>
            Watch our students in action and discover the exciting world of technology
          </p>
        </motion.div>

        <motion.div
          className="video-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {videos.map((video) => (
            <motion.div
              key={video.id}
              className="video-item"
              variants={itemVariants}
              onClick={() => openYouTubeVideo(video.youtubeId)}
            >
              <div className="video-thumbnail">
                <img src={video.thumbnail} alt={video.title} />
                <div className="play-button">
                  <svg viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
                <div className="video-overlay">
                  <h3>{video.title}</h3>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>


      </div>
    </section>
  );
};

export default VideoGallerySection; 